/* Present Pickentory's white/color card prices as a white-shirt deal.
   order-panel.js fills .pkt-gp with "White shirts $X/ea" and "Color shirts $Y/ea"; we rewrite it to
   "From $Y" with a "White −Z%" tag and "$X on white". Both prices are the real Pickentory prices,
   and the percentage is computed from them. */
(function () {
  if (window.__osdtgWhiteDeal) return;
  window.__osdtgWhiteDeal = true;

  function amount(line) {
    var el = line && line.querySelector('.pkt-gp-amt');
    var m = el && (el.textContent || '').replace(/,/g, '').match(/[\d.]+/);
    return m ? { text: el.textContent.trim(), value: parseFloat(m[0]) } : null;
  }

  function transform(box) {
    if (box.getAttribute('data-osdtg-deal') === '1') return;
    var lines = box.querySelectorAll('.pkt-gp-line');
    var white = null, color = null;
    lines.forEach(function (l) {
      var t = (l.textContent || '').toLowerCase();
      if (t.indexOf('white') === 0) white = amount(l);
      else if (t.indexOf('color') === 0 || t.indexOf('colour') === 0) color = amount(l);
    });
    if (!white && !color) return;
    box.setAttribute('data-osdtg-deal', '1');

    // Single line: "From <lowest real price>" (usually the white-shirt price).
    var lowest = white && color ? (white.value <= color.value ? white : color) : (white || color);
    box.innerHTML = '<div class="osdtg-wd__main"><span class="osdtg-wd__from">From</span> <strong>' + lowest.text + '</strong></div>';
    box.classList.add('osdtg-wd');
  }

  function scan(root) {
    (root || document).querySelectorAll('.pkt-gp[data-filled="1"]').forEach(transform);
  }

  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (t.nodeType === 1 && (t.matches('.pkt-gp') || t.querySelector('.pkt-gp'))) { scan(); return; }
    }
  });

  function start() {
    scan();
    mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-filled'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
